// features/licenses/state.ts
import type { LicensesState } from "./types";

export const initialState: LicensesState = {
  data: [],
  selected: null,
  loading: false,
  error: null,
  managementDrawerOpen: false,
  loadingCancelMainLicense: false,
};
